<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-07 14:35:04
 -->
<template>
  <ul class="part9">
    <div class="title">
      到达时乘坐的交通工具 Transportation · We will travel to the World Choir
      Games by …
    </div>
    <ul class="lis">
      <li>
        <el-radio
          v-model="part9.type"
          label="0"
          :disabled="stateCode==6||stateCode==0?false:true"
        >我们自行安排的巴士，而且全程都用它</el-radio>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="1"
          :disabled="stateCode==6||stateCode==0?false:true"
        >我们乘飞机抵达</el-radio>
        <input
          type="text"
          v-model="part9.airAddressCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> 机场（地点）,
        航空公司
        <input
          type="text"
          v-model="part9.airCompanyCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        />航班号
        <input
          type="text"
          v-model="part9.airCodeCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        />
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.airShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >是否需要组委会安排送达酒店的交通工具？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.airradio" label="1">是</el-radio>
            <el-radio v-model="part9.airradio" label="2">否</el-radio>
          </div>-->
        </div>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="2"
          :disabled="stateCode==6||stateCode==0?false:true"
        >我们乘火车抵达</el-radio>
        <input
          type="text"
          v-model="part9.trainAddressCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> （地点）
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.trainShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >是否需要组委会安排送达酒店的交通工具？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.trainradio" label="1">是</el-radio>
            <el-radio v-model="part9.trainradio" label="2">否</el-radio>
          </div>-->
        </div>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="3"
          :disabled="stateCode==6||stateCode==0?false:true"
        >其他交通方式抵达:</el-radio>
        <input
          type="text"
          v-model="part9.otherAddressCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> （地点）
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.otheShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >是否需要组委会安排送达酒店的交通工具？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.otherradio" label="1">是</el-radio>
            <el-radio v-model="part9.otherradio" label="2">否</el-radio>
          </div>-->
        </div>
      </li>
    </ul>
    <ul class="lis" style="margin-top: 20px">
      <li>
        <el-radio v-model="part9.type" label="0" :disabled="stateCode==6||stateCode==0?false:true">
          tourbus (to be organized by ourselves) which we will have at our
          disposal during the entire stay
        </el-radio>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="1"
          :disabled="stateCode==6||stateCode==0?false:true"
        >plane - Airport of arrival:</el-radio>
        <input
          type="text"
          v-model="part9.airAddressEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> Airline:
        <input
          type="text"
          v-model="part9.airCompanyEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        />flight number:
        <input
          type="text"
          v-model="part9.airCodeEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        />
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.airShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >transfer to our accomodation is necessary？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.airradioEn" label="1">yes</el-radio>
            <el-radio v-model="part9.airradioEn" label="2">no</el-radio>
          </div>-->
        </div>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="2"
          :disabled="stateCode==6||stateCode==0?false:true"
        >train (to be organized by ourselves) to</el-radio>
        <input
          type="text"
          v-model="part9.trainAddressEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> （地点）
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.trainShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >transfer to our accomodation is necessary？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.trainradioEn" label="1">yes</el-radio>
            <el-radio v-model="part9.trainradioEn" label="2">no</el-radio>
          </div>-->
        </div>
      </li>
      <li>
        <el-radio
          v-model="part9.type"
          label="3"
          :disabled="stateCode==6||stateCode==0?false:true"
        >other means of transportation to</el-radio>
        <input
          type="text"
          v-model="part9.otherAddressEn"
          :disabled="stateCode==6||stateCode==0?false:true"
        /> （地点）
        <br />
        <div style="display: flex">
          <div style="color: #24558b; margin-left: 22px">
            <el-checkbox
              v-model="part9.otheShuttle"
              :disabled="stateCode==6||stateCode==0?false:true"
            >transfer to our accomodation is necessary？</el-checkbox>
          </div>
          <!-- <div>
            <el-radio v-model="part9.otherradioEn" label="1">yes</el-radio>
            <el-radio v-model="part9.otherradioEn" label="2">no</el-radio>
          </div>-->
        </div>
      </li>
    </ul>
    <div class="text">
      <p>
        <span>协议：我们完全同意接受报名指南中所有条款（比赛规则、报名指南）</span>
        <br />同时认可组委会指定的机构所提供的住宿和餐饮等一揽子服务，并了解此为参赛的必要前提。
      </p>
      <p>
        <span>We fully accept all conditions of the Participation Information</span>
        in the name of all participants. Furthermore, we accept that the event
        package will be booked through the authorized agency M&C Music Contact
        GmbH. We have taken note of the information on data protection.
      </p>
    </div>
    <ul class="part9s">
      <li>
        <el-input
          placeholder="请输入内容"
          v-model="part9.fillCityCountryCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">填表地点（城市，国家）：</template>
        </el-input>
        <el-input
          placeholder="yyyy.MM.dd"
          v-model="part9.fillTableDateCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">填表日期：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part9.linkmanSignatureCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">合唱团联系人签名：</template>
        </el-input>
        <el-input
          placeholder="请输入内容"
          v-model="part9.commandSignatureCh"
          :disabled="stateCode==6||stateCode==0?false:true"
        >
          <template slot="prepend">指挥/艺术总监签名：</template>
        </el-input>
      </li>
      <li class="lengbox">
        <div class="box">
          <div class="box1">
            <label for>
              City,Country：
              <input
                type="text"
                v-model="part9.fillCityCountryEn"
                :disabled="stateCode==6||stateCode==0?false:true"
              />
            </label>
          </div>
        </div>
        <div class="box">
          <div class="box1">
            <label for>Date：</label>
            <input
              type="text"
              v-model="part9.fillTableDateEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>
        <div class="box">
          <div class="box1">
            <label for>Signature of the contact person：</label>
            <input
              type="text"
              v-model="part9.linkmanSignatureEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>
        <div class="box">
          <div class="box1">
            <label for>Signature of the artistic director/conductor：</label>
            <input
              type="text"
              v-model="part9.commandSignatureEn"
              :disabled="stateCode==6||stateCode==0?false:true"
            />
          </div>
        </div>
      </li>
    </ul>
  </ul>
</template>

<script>
export default {
  props: {
    Transportationh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      part9: {
        airAddressCh: "", //机场（地点）,
        airAddressEn: "", //机场（地点）,
        airCompanyCh: "", //航空公司
        airCompanyEn: "", //航空公司
        airCodeCh: "", //航班号
        airCodeEn: "", //航班号
        airShuttle: false, //是否需要组委会安排送达酒店的交通工具？
        trainAddressCh: "", //火车（地点）
        trainAddressEn: "", //火车（地点）
        trainShuttle: false, ////是否需要组委会安排送达酒店的交通工具？
        otherAddressCh: "", //其他交通方式（地点）
        otherAddressEn: "", //其他交通方式（地点）
        otheShuttle: false, ////是否需要组委会安排送达酒店的交通工具？
        fillCityCountryCh: "", //填表地点（城市，国家）
        fillCityCountryEn: "", //填表地点（城市，国家）
        fillTableDateCh: "", //填表日期
        fillTableDateEn: "", //填表日期
        linkmanSignatureCh: "", //合唱团联系人签名
        linkmanSignatureEn: "", //合唱团联系人签名
        commandSignatureCh: "", //指挥/艺术总监签名
        commandSignatureEn: "", //指挥/艺术总监签名
        type: "0",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.part9.type = this.Transportationh.type.toString();
      this.part9.airAddressCh = this.Transportationh.airAddressCh;
      this.part9.airAddressEn = this.Transportationh.airAddressEn;
      this.part9.airCompanyCh = this.Transportationh.airCompanyCh;
      this.part9.airCompanyEn = this.Transportationh.airCompanyEn;
      this.part9.airCodeCh = this.Transportationh.airCodeCh;
      this.part9.airCodeEn = this.Transportationh.airCodeEn;
      this.part9.airShuttle = this.Transportationh.airShuttle;
      this.part9.trainAddressCh = this.Transportationh.trainAddressCh;
      this.part9.trainAddressEn = this.Transportationh.trainAddressEn;
      this.part9.trainShuttle = this.Transportationh.trainShuttle;

      this.part9.otherAddressCh = this.Transportationh.otherAddressCh;
      this.part9.otherAddressEn = this.Transportationh.otherAddressEn;
      this.part9.otheShuttle = this.Transportationh.otheShuttle;
      this.part9.fillCityCountryCh = this.Transportationh.fillCityCountryCh;
      this.part9.fillCityCountryEn = this.Transportationh.fillCityCountryEn;
      this.part9.fillTableDateCh = this.Transportationh.fillTableDateCh;
      this.part9.fillTableDateEn = this.Transportationh.fillTableDateEn;

      this.part9.linkmanSignatureCh = this.Transportationh.linkmanSignatureCh;
      this.part9.linkmanSignatureEn = this.Transportationh.linkmanSignatureEn;
      this.part9.commandSignatureCh = this.Transportationh.commandSignatureCh;
      this.part9.commandSignatureEn = this.Transportationh.commandSignatureEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part9 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }
  .lis {
    li {
      border: 1px solid gainsboro;
      margin-left: 100px;
      margin-right: 100px;
      // padding-left: 10px;
      // padding-right: 0px;
      padding: 10px 0 10px 10px;
      label {
        color: rgba(36, 85, 139, 1);
      }
      input {
        outline: none;
        border: 0;
        border-bottom: 1px solid gray;
      }
      .el-checkbox {
        line-height: 34px;
        .el-checkbox__label {
          input {
            outline: none;
            border: 0;
            border-bottom: 1px solid gray;
          }
        }
      }
      /deep/ .el-radio__label {
        color: rgba(36, 85, 139, 1);
      }
    }
  }
  .text {
    margin: auto;
    margin-left: 100px;
    margin-right: 100px;
    line-height: 40px;
    margin-top: 46px;
    p {
      font-size: 20px;
      span {
        font-size: 24px;
      }
    }
  }
  .part9s {
    margin-top: 10px;
    .lengbox {
      margin-top: 10px;

      label {
        color: rgba(36, 85, 139, 1);
      }
      input {
        outline: none;
        border: 0;
        border-bottom: 1px solid gray;
        display: inline-block;
      }
      .box {
        border: 1px solid #dcdfe6;
        .box1 {
          padding: 0 20px;
          // display: flex;
        }
        &:nth-of-type(1) {
          width: 29%;
        }
        &:nth-of-type(2) {
          width: 21%;
        }
        &:nth-of-type(3) {
          width: 25%;
        }
        &:nth-of-type(4) {
          width: 25%;
        }
      }
    }

    li {
      display: flex;
      padding-left: 100px;
      padding-right: 100px;

      .el-input {
        /deep/ .el-input-group__prepend {
          border-right: 0;
          color: rgba(36, 85, 139, 1);
          background: white;
          padding-right: 0px;
        }
        /deep/.el-input__inner {
          border-left: 0;
          padding: 0 15px 0 0;
          &:focus {
            border-color: #dcdfe6;
            outline: 0;
          }
        }
        &:nth-of-type(1) {
          width: 29%;
        }
        &:nth-of-type(2) {
          width: 21%;
        }
        &:nth-of-type(3) {
          width: 25%;
        }
        &:nth-of-type(4) {
          width: 25%;
        }
      }

      .radiobox {
        width: 30%;
        border: 1px solid gainsboro;
        .el-radio {
          margin-left: 30px;
          margin-top: 14px;
        }
      }
      p {
        color: rgba(36, 85, 139, 1);
        line-height: 32px;
      }
    }

    li:nth-of-type(5) {
      margin-top: 20px;
    }
  }
}
</style>
